import store from "@/store";

export default function(error) {
	let message = '';
	if (error) {
		for (const key in error) {
			(error[key].length > 1)
				? error[key].forEach(item => (message += `<span>${ item }</span>`))
				: message += `<span>${ error[key].toString() }</span>`;
		}
	}

	if (message) store.dispatch("setAlert", { type: "error", message });
}
